var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBiZcard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ZCARD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "icon-path"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 0 11.78 1.2 9.65 1.2 1.23 13.8 1.23 13.8 7.63 10.81 12.93 10.81 12.94 10.8 12.95 8.69 12.95 4.88 19.7 9.04 19.7 15 9.19 15 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "13.8 21.77 1.2 21.77 1.2 15.42 4.15 10.19 6.23 10.19 10.09 3.33 5.94 3.33 4.17 6.46 4.13 6.53 1.2 11.73 0 13.84 0 23 15 23 15 11.29 13.8 13.42 13.8 21.77"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiZcard);
export default __webpack_public_path__ + "static/media/bi-zcard.9338afe5c2d72e7f29cbe39155420efe.svg";
export { ForwardRef as ReactComponent };